export const loadingConstants = {
    START: 'LOADNG_START',
    STOP: 'LOADING_STOP' , 
    CLEAR : 'LOADING_CLEAR'
};



// WEBPACK FOOTER //
// ./src/_constants/loading.constants.js